export default "__VITE_ASSET__C1ipV$Cu__"